import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star, X } from 'lucide-react';
import styles from './AnimatedReviewWidget.module.css';

const AnimatedReviewWidget: React.FC = () => {
  const [currentReviewIndex, setCurrentReviewIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  // 50 sample reviews
  const reviews = [
    // 15 Tunglish (Tamil-English mix) reviews
    { name: "Karthik", course: "B.Tech CSE", text: "College la atmosphere semma! Hostel food ok va irukkum, but konjam spicy. Placement chance nalla irukku, just hard work pannanum bro!", rating: 5 },
    { name: "Priya", course: "MBBS Student", text: "Faculty ellam helpful, campus la konjam crowd irukkum. Lab facilities super ah irukku, library la silence. Overall, good experience!", rating: 4 },
    { name: "Arun", course: "Mechanical Engg", text: "Fees konjam adhigam, but value irukku. Friends kitta pesina, avanga kuda satisfied. Sports ground la evening time super vibe!", rating: 5 },
    { name: "Divya", course: "BSc Nursing", text: "Nursing course romba practical. Hostel la friends kitta fun, but assignments tight ah irukkum. Staff support nalla irukku!", rating: 4 },
    { name: "Sathish", course: "MBA Student", text: "MBA la placement training semma. Interview tips kuduthanga, na confident ah feel panninen. Campus life super!", rating: 5 },
    { name: "Lakshmi", course: "B.Com", text: "Commerce class la sir explanation super. Exams easy ah irundhudhu, but assignment ellam konjam kashtam.", rating: 4 },
    { name: "Vignesh", course: "BBA", text: "Management subject la group project nalla irundhudhu. Hostel la wifi speed ok va irukkum.", rating: 5 },
    { name: "Meena", course: "BSc Physics", text: "Physics lab la experiment pannradhu romba interesting. Friends kitta notes share pannuvom.", rating: 4 },
    { name: "Saravanan", course: "BE Civil", text: "Site visit ku college arrange pannanga, practical knowledge semma. Hostel mess la food variety irukkum.", rating: 5 },
    { name: "Anitha", course: "BSc Chemistry", text: "Chemistry practical la staff support nalla irukku. Library la book collection super.", rating: 4 },
    { name: "Ramesh", course: "BCA", text: "Computer lab la systems ellam latest. Coding class la sir patience ah explain pannuvanga.", rating: 5 },
    { name: "Keerthi", course: "BDS", text: "Dental college la clinical exposure nalla irukku. Hostel la safety semma.", rating: 4 },
    { name: "Suresh", course: "BE ECE", text: "Electronics subject la project work romba useful. Placement training nalla irukku.", rating: 5 },
    { name: "Gayathri", course: "BSc Maths", text: "Maths department la faculty friendly. Hostel la festival celebration super.", rating: 4 },
    { name: "Manoj", course: "BPT", text: "Physiotherapy practical la hands-on experience semma. Hostel la maintenance nalla irukku.", rating: 5 },

    // 10 Pure English reviews
    { name: "Rajesh", course: "B.Tech IT", text: "The campus is beautiful and the faculty are very supportive. I enjoyed my time here.", rating: 5 },
    { name: "Dharshini", course: "MBA", text: "Placements are excellent and the training sessions helped me a lot. Highly recommended!", rating: 5 },
    { name: "Leeha", course: "BSc Physics", text: "Lab facilities are top-notch and the curriculum is very practical.", rating: 4 },
    { name: "Sophia", course: "BDS", text: "Dental college provides great clinical exposure and the hostel is safe.", rating: 5 },
    { name: "Deepan", course: "BE Mechanical", text: "Mechanical engineering department is well equipped and the staff are knowledgeable.", rating: 5 },
    { name: "Niranjana", course: "BSc Nursing", text: "Nursing course is very hands-on and the staff are supportive.", rating: 4 },
    { name: "kanishka", course: "BBA", text: "Management subjects are taught well and group projects are fun.", rating: 5 },
    { name: "varsha", course: "BCom", text: "Commerce classes are easy to follow and assignments are manageable.", rating: 4 },
    { name: "Ragul", course: "BE Civil", text: "Site visits and practical knowledge are the highlights of the civil department.", rating: 5 },
    { name: "Shiva bharathi", course: "BSc Chemistry", text: "Chemistry labs are well maintained and the library has a great collection.", rating: 4 },

    // Add consultancy-specific Tunglish and English reviews
    { name: "Raja", course: "Consultancy Service", text: "Consultancy la guidance semma. College choose panna help pannanga, doubts clear ah solrangale!", rating: 5 },
    { name: "Nithya", course: "Consultancy", text: "EduConsult team nalla support kuduthanga. Abroad studies ku process easy ah irundhudhu!", rating: 5 },
    { name: "Ajay", course: "Consultancy", text: "Admission process la consultancy team romba helpful. Scholarship details ellam explain pannanga.", rating: 4 },
    { name: "Deepa", course: "Consultancy", text: "Consultancy la staff polite ah irundhanga. Application process smooth ah mudichitten.", rating: 5 },
    { name: "Vasanth", course: "Consultancy", text: "EduConsult la counseling session attend panninen, doubts ellam clear aayiduchu!", rating: 5 },
    { name: "Sneha", course: "Consultancy", text: "Consultancy la abroad studies ku information nalla kuduthanga. Visa process easy!", rating: 4 },
    { name: "Praveen", course: "Consultancy", text: "College selection la consultancy team romba patient ah irundhanga. Nalla experience!", rating: 5 },
    { name: "Ramya", course: "Consultancy", text: "EduConsult la interview preparation semma. Confidence level increase aayiduchu!", rating: 5 },
    { name: "Harish", course: "Consultancy", text: "Consultancy la education loan details ellam explain pannanga. Useful ah irundhudhu.", rating: 4 },
    { name: "Meera", course: "Consultancy", text: "EduConsult la admission process fast ah mudichanga. Thanks for the support!", rating: 5 },
    // English consultancy reviews
    { name: "Amit", course: "Consultancy", text: "The consultancy team guided me through every step of the admission process. Highly professional!", rating: 5 },
    { name: "Sara", course: "Consultancy", text: "Visa process was made easy by the consultancy. I am grateful for their help.", rating: 5 },
    { name: "Kevin", course: "Consultancy", text: "Interview preparation sessions boosted my confidence. Great experience!", rating: 5 },
    { name: "Priya", course: "Consultancy", text: "Consultancy provided all the information I needed for my studies abroad.", rating: 4 },
    { name: "Vikram", course: "Consultancy", text: "Education loan guidance was very helpful. The staff are knowledgeable.", rating: 5 },
  ];

  // Auto-cycle through reviews every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentReviewIndex((prev) => (prev + 1) % reviews.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [reviews.length]);

  const currentReview = reviews[currentReviewIndex];

  if (!isVisible) {
    return (
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        className="fixed bottom-8 right-8 z-50"
      >
        <button
          onClick={() => setIsVisible(true)}
          className="bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white p-2 rounded-full shadow-2xl transition-all duration-300 border-2 border-white"
          title="Show Reviews"
        >
          <Star className="h-5 w-5 text-yellow-300 fill-current" />
        </button>
      </motion.div>
    );
  }

  return (
    <motion.div
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      className="fixed bottom-8 right-8 z-50"
    >
      <div className="w-80 max-w-sm bg-gradient-to-br from-purple-600 via-pink-400 to-cyan-400 rounded-2xl shadow-2xl border border-cyan-200 overflow-hidden font-[Quicksand,Inter,Poppins,sans-serif] text-white">
        {/* Header with close button */}
        <div className="bg-gradient-to-r from-black via-blue-900 to-blue-600 text-white p-3 flex items-center justify-between relative">
          <div className="flex items-center space-x-2">
            <motion.div
              animate={{ rotate: 360 }}
              transition={{ duration: 3, repeat: Infinity, ease: 'linear' }}
            >
              <Star className="h-5 w-5 text-yellow-300 fill-current" />
            </motion.div>
            <span className="font-bold text-lg tracking-wide drop-shadow">Student Reviews</span>
          </div>
          <div className="flex items-center space-x-4">
        
            <button
              onClick={() => setIsVisible(false)}
              className="text-white hover:text-cyan-200 transition-colors"
              title="Hide Reviews"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        </div>
        {/* Review Content */}
        <div className="p-4">
          <AnimatePresence mode="wait">
            <motion.div
              key={currentReviewIndex}
              initial={{ opacity: 0, y: 20, scale: 0.9 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: -20, scale: 0.9 }}
              transition={{ duration: 0.5 }}
              className="space-y-3"
            >
              {/* Rating Stars */}
              <div className="flex items-center justify-center space-x-1">
                {[...Array(currentReview.rating)].map((_, i) => (
                  <motion.div
                    key={i}
                    initial={{ scale: 0, rotate: -180 }}
                    animate={{ scale: 1, rotate: 0 }}
                    transition={{ delay: i * 0.1, type: "spring" }}
                  >
                    <Star className="h-4 w-4 text-yellow-400 fill-current" />
                  </motion.div>
                ))}
                {[...Array(5 - currentReview.rating)].map((_, i) => (
                  <Star key={i} className="h-4 w-4 text-gray-300" />
                ))}
              </div>
              {/* Review Text */}
              <div className="text-center">
                <p className="text-white text-lg leading-relaxed italic font-[Quicksand,Inter,Poppins,sans-serif] drop-shadow">
                  "{currentReview.text}"
                </p>
              </div>
              {/* Student Info */}
              <div className="text-center pt-2">
                <div className="font-semibold text-blue-900 text-sm">
                  {currentReview.name}
                </div>
                <div className="text-xs text-blue-600 font-medium">
                  {currentReview.course}
                </div>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
        {/* Progress Indicator */}
        <div className="h-1 bg-gray-200">
          <motion.div
            className="h-full bg-gradient-to-r from-blue-500 to-indigo-500"
            initial={{ width: "0%" }}
            animate={{ width: "100%" }}
            transition={{ duration: 5, repeat: Infinity, ease: "linear" }}
          />
        </div>
      </div>
    </motion.div>
  );
};

export default AnimatedReviewWidget;